<template>
  <v-container>
    <v-card flat color="transparent">
      <v-card-title class="white--text text-h5 font-weight-bold">Angebote</v-card-title>
      <v-card-subtitle class="white--text pb-4"> Wähle die Angebote aus, die für dieses Studio auf der Webseite aktiv sein sollen. </v-card-subtitle>

      <v-alert v-if="offers.length === 0" type="info" class="mt-4" text> Keine Angebote zur Auswahl gefunden. </v-alert>

      <v-row v-else>
        <v-col v-for="item in offers" :key="item._id" cols="12" sm="6" md="4">
          <v-card class="item-card text-center d-flex flex-column" :class="{ 'is-selected': item.isSelected }" @click="handleToggle(item)" hover>
            <div class="selected-indicator" v-if="item.isSelected">
              <v-icon color="white">mdi-check-circle</v-icon>
            </div>

            <div class="item-card-icon-container">
              <v-icon size="50" :color="item.isSelected ? 'primary' : 'white'">
                {{ item.icon || "mdi-star-outline" }}
              </v-icon>
            </div>

            <v-card-title class="justify-center pt-3 pb-1">
              {{ item.title }}
            </v-card-title>

            <v-card-text class="white--text font-weight-light flex-grow-1">
              {{ item.description }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import api from "@/api"

export default {
  data() {
    return {
      offers: [],
    }
  },
  created() {
    this.fetchOffers()
  },
  methods: {
    async fetchOffers() {
      try {
        this.offers = await api.fetchOffers()
      } catch (error) {
        this.$toast.error("Fehler beim Laden der Angebote.")
      }
    },
    handleToggle(item) {
      // Zustand sofort ändern für besseres User-Feedback
      item.isSelected = !item.isSelected
      // API-Call im Hintergrund ausführen
      this.toggleStudio(item._id, item.isSelected)
    },
    async toggleStudio(id, isSelected) {
      const action = isSelected ? "add" : "remove"
      try {
        await api.toggleOfferService(id, action)
      } catch (error) {
        this.$toast.error("Änderung konnte nicht gespeichert werden.")
        // Bei einem Fehler den Zustand zurücksetzen
        const item = this.offers.find((o) => o._id === id)
        if (item) {
          item.isSelected = !isSelected
        }
      }
    },
  },
}
</script>

<style scoped>
.item-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-radius: 12px !important;
  background: linear-gradient(145deg, #2a2a2a, #1e1e1e);
  box-shadow: 5px 5px 15px #1c1c1c, -5px -5px 15px #2e2e2e;
  border: 2px solid transparent;
  position: relative;
  height: 100%;
}

.item-card.is-selected {
  border-color: var(--v-primary-base);
  box-shadow: 0 0 20px rgba(var(--v-primary-base-rgb), 0.5);
}

.item-card:hover {
  transform: translateY(-5px);
}

.item-card-icon-container {
  padding-top: 24px;
}

.selected-indicator {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: var(--v-primary-base);
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
</style>
